import { definePlayerFeature } from "../../feature.js";
import { isFullscreen } from "../../presentation/fullscreen.js";
import { createScreenOrientationLock } from "../../presentation/orientation.js";
import { createSelector } from "@videojs/store";
import { listen } from "@videojs/utils/dom";
import { isNull } from "@videojs/utils/predicate";
//#region src/dom/store/features/orientation-lock.ts
const DEFAULT_ORIENTATION_LOCK_TYPE = "landscape";
/**
* Locks screen orientation while fullscreen is active.
*
* The orientation type is provider configuration, so it can change during the player's lifetime. Unsupported browsers
* and rejected lock requests are ignored.
*/
const orientationLockFeature = definePlayerFeature({
	name: "orientationLock",
	config: { 
	/** Screen orientation type to lock while fullscreen is active. */
orientationLockType: {
		action: "setOrientationLockType",
		state: "orientationLockType"
	} },
	state: ({ set }) => ({
		orientationLockType: DEFAULT_ORIENTATION_LOCK_TYPE,
		setOrientationLockType: (value) => set({ orientationLockType: value || DEFAULT_ORIENTATION_LOCK_TYPE })
	}),
	attach({ target, signal, get, store }) {
		const { media, container } = target;
		const orientationLock = createScreenOrientationLock();
		let synced = null;
		const sync = () => {
			const next = isFullscreen(container, media) ? get().orientationLockType : null;
			if (next === synced) return;
			synced = next;
			if (isNull(next)) orientationLock.unlock();
			else orientationLock.lock(next);
		};
		sync();
		listen(document, "fullscreenchange", sync, { signal });
		listen(document, "webkitfullscreenchange", sync, { signal });
		if ("webkitPresentationMode" in media) listen(media, "webkitpresentationmodechanged", sync, { signal });
		const unsubscribe = store.subscribe(sync);
		signal.addEventListener("abort", () => {
			unsubscribe();
			orientationLock.unlock();
		}, { once: true });
	}
});
/**
* Select the orientation lock state (`orientationLockType`, `setOrientationLockType`). Returns `undefined` when the
* feature is not configured.
*/
const selectOrientationLock = createSelector(orientationLockFeature);
//#endregion
export { orientationLockFeature, selectOrientationLock };

//# sourceMappingURL=orientation-lock.js.map